const React = require("react");

function ArrowNarrowRightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 8l4 4m0 0l-4 4m4-4H3"
  }));
}

module.exports = ArrowNarrowRightIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/ArrowNarrowRightIcon.js
 ** module id = 439
 ** module chunks = 0
 **/